import { render, staticRenderFns } from "./CreateEditSMTPServer.vue?vue&type=template&id=55b38ec6&scoped=true&"
import script from "./CreateEditSMTPServer.vue?vue&type=script&lang=ts&"
export * from "./CreateEditSMTPServer.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEditSMTPServer.vue?vue&type=style&index=0&id=55b38ec6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b38ec6",
  null
  
)

export default component.exports